// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export type {
  StorageManagementContext,
  StorageManagementClientOptionalParams,
} from "./storageManagementContext.js";
export { createStorageManagement } from "./storageManagementContext.js";
